/**
 * 最近チェックしたアイテム機能
 * - 商品ページを開くたびに、その商品のhandleをlocalStorageに記録する（未ログインでも動作）
 * - <recently-viewed-products>タグが設置された場所に、記録済みの商品を新しい順にカード表示する
 */
(function () {
  if (window.HJRecentlyViewed && window.HJRecentlyViewed.initialized) return;

  var STORAGE_KEY = 'hj_recently_viewed_products';
  var MAX_ITEMS = 10;

  function getRecentlyViewed() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  }

  function recordRecentlyViewed(handle) {
    if (!handle) return;
    try {
      var list = getRecentlyViewed().filter(function (item) {
        return item !== handle;
      });
      list.unshift(handle);
      if (list.length > MAX_ITEMS) {
        list = list.slice(0, MAX_ITEMS);
      }
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (error) {
      // localStorageが使用不可（プライベートモード等）の場合は何もしない
    }
  }

  function recordCurrentProduct() {
    var recordTarget = document.querySelector('[data-record-recently-viewed]');
    if (recordTarget) {
      recordRecentlyViewed(recordTarget.getAttribute('data-record-recently-viewed'));
    }
  }

  function refreshRecentlyViewedSections() {
    document.querySelectorAll('recently-viewed-products').forEach(function (section) {
      if (typeof section.refresh === 'function') {
        section.refresh();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    recordCurrentProduct();
  });

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    recordCurrentProduct();
    refreshRecentlyViewedSections();
  });

  class RecentlyViewedProducts extends HTMLElement {
    connectedCallback() {
      this.refresh();
    }

    refresh() {
      const excludeHandle = this.dataset.excludeHandle || '';
      const limit = parseInt(this.dataset.limit, 10) || MAX_ITEMS;
      const renderToken = String(Date.now());
      this.dataset.renderToken = renderToken;

      const handles = getRecentlyViewed()
        .filter((handle) => handle !== excludeHandle)
        .slice(0, limit);

      const list = this.querySelector('[data-recently-viewed-list]');
      if (!list) {
        this.classList.add('recently-viewed-products--hidden');
        return;
      }

      list.innerHTML = '';

      if (!handles.length) {
        this.classList.add('recently-viewed-products--hidden');
        return;
      }

      const isSlider = list.classList.contains('slider');

      Promise.all(handles.map((handle) => this.fetchCardHtml(handle)))
        .then((cardsHtml) => {
          if (this.dataset.renderToken !== renderToken) return;

          const fragment = document.createDocumentFragment();
          let count = 0;

          cardsHtml.forEach((html) => {
            if (!html) return;
            const li = document.createElement('li');
            // slider-component が `[id^="Slide-"]` でスライドを検出するため、このID規則に合わせる
            li.id = `Slide-${this.dataset.sectionId}-${count + 1}`;
            li.className = isSlider ? 'grid__item slider__slide' : 'grid__item';
            li.innerHTML = html;
            fragment.appendChild(li);
            count++;
          });

          if (!count) {
            this.classList.add('recently-viewed-products--hidden');
            return;
          }

          list.appendChild(fragment);
          this.classList.remove('recently-viewed-products--hidden');

          const slider = this.querySelector('slider-component');
          if (slider && typeof slider.resetPages === 'function') {
            slider.resetPages();
          }
        })
        .catch(() => {
          this.classList.add('recently-viewed-products--hidden');
        });
    }

    fetchCardHtml(handle) {
      return fetch(`/products/${encodeURIComponent(handle)}?view=recently-viewed-card`)
        .then((response) => (response.ok ? response.text() : ''))
        .catch(() => '');
    }
  }

  if (!customElements.get('recently-viewed-products')) {
    customElements.define('recently-viewed-products', RecentlyViewedProducts);
  }

  window.HJRecentlyViewed = {
    initialized: true,
    record: recordRecentlyViewed,
    get: getRecentlyViewed,
    refresh: refreshRecentlyViewedSections,
  };
})();
